<template>
  <v-container id="indicador-prazos-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <indicador-prazos-tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import IndicadorPrazosService from '@/services/IndicadorPrazosService';
  import pusherMixins from '@/mixins/pusherMixins';
  import dayjs from 'dayjs';

  export default {
    components: {
      IndicadorPrazosTabela: () => import('@/components/indicadorPrazos/Tabela')
    },
    mixins: [pusherMixins],

    data() {
      return {
        items: [],
        loading: false,
        processamentosExpirados: false
      };
    },

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refresh-indicador-prazos', () => {
          this.getAll();
        });
      },
      getAll() {
        this.loading = true;

        IndicadorPrazosService.getAll(this.processamentosExpirados)
          .then((response) => {
            this.items = [];

            response.data.indicadores.forEach((element) => {
              this.items.push({
                id: element.id,
                titulo: element.titulo,
                obras: element.obras,
                status: element.status,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                created: element.created,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                data_imobilizacao_inicio: element.data_imobilizacao_inicio,
                data_imobilizacao_fim: element.data_imobilizacao_fim
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar os Indicadores de Prazos.', '', {
              position: 'topRight'
            });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
